import { Directive, ElementRef, Injector, Input } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({
    selector: 'tt-ie-http-img',
})
export class IeHttpSrcDirective extends UpgradeComponent {
    @Input()
    public imageUrl: string = '';

    @Input()
    public applicationId?: string = '';

    constructor(elementRef: ElementRef<HTMLElement>, injector: Injector) {
        super('ttIeHttpSrcBridge', elementRef, injector);
        elementRef.nativeElement.classList.add('col-xs-12', 'sp-0');
        elementRef.nativeElement.style.maxHeight = '40rem';
    }
}
